import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref, Ref } from 'vue';

import {
  NavBar,
  Heading,
  Row,
  ButtonIconContextual,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { PasswordModal } from '../PasswordModal';
import { IMarginAllocation } from '@/modules/trade/services/margin-allocation';
import { EMarginAllocationSteps } from '@/modules/trade/views/MarginAllocation/helpers';

interface IDataForm {
  balance: { value: number; formatted: string };
  drawdown: { value: number; formatted: string };
  isUpdatingLimits: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Review',
  setup(__props) {

const changeStep = inject('changeStep', (step: EMarginAllocationSteps) => ({
  step
}));
const fetchUpdateLimits = inject('fetchUpdateLimits', () => ({}));
const dataForm = inject('dataForm') as Ref<IDataForm>;
const marginAllocation = inject('marginAllocation') as Ref<IMarginAllocation>;

const isPasswordModalOpen = ref(false);

const isFirstTime = computed(() => {
  return marginAllocation.value.isFirstTime;
});

const details = computed(() => {
  return [
    {
      title: 'Saldo day trade',
      subtitle: `R$ ${dataForm.value.balance.formatted}`,
      step: EMarginAllocationSteps.BALANCE
    },
    {
      title: 'Prejuízo máximo',
      subtitle: `R$ ${dataForm.value.drawdown.formatted}`,
      step: EMarginAllocationSteps.DRAWDOWN
    }
  ];
});

function confirmPassword() {
  isPasswordModalOpen.value = false;

  fetchUpdateLimits();
}

function goToEdit(step: EMarginAllocationSteps) {
  changeStep(step);
}

function handleBack() {
  changeStep(EMarginAllocationSteps.DRAWDOWN);
}

return { __sfc: true,changeStep, fetchUpdateLimits, dataForm, marginAllocation, isPasswordModalOpen, isFirstTime, details, confirmPassword, goToEdit, handleBack, NavBar, Heading, Row, ButtonIconContextual, ButtonContainer, ButtonPrimary, BackButton, PasswordModal }
}

})